import OldProjectFile from "@/models/entities/old/ProjectFile";
import ProjectFile from "@/models/entities/ProjectFile";

export const convertOldProjectFileToNew = (oldFile:OldProjectFile):ProjectFile => {
    const result = new ProjectFile();

    result.name = oldFile.name;
    result.downloadToken = oldFile.urlGuid;
    result.sizeInBytes = oldFile.size as number;
    result.type = oldFile.type;
    result.description = oldFile.desc;
    result.file = oldFile.file;
    result.messageToCreator = oldFile.messageToCreator;

    return result;
}

export const convertNewProjectFileToOld = (newFile:ProjectFile):OldProjectFile => {
    const result = new OldProjectFile();

    result.name = newFile.name;
    result.urlGuid = newFile.downloadToken;
    result.size = newFile.sizeInBytes;
    result.type = newFile.type;
    result.desc = newFile.description ?? "";
    result.file = newFile.file;
    result.messageToCreator = newFile.messageToCreator;

    return result;
}